export const COMPANY = {
  name: "Global Pneus",
  logo: "/logo-global-pneus.png",
  partnerLogo: "/logo-confortauto.png",
  partnerName: "ConfortAuto",
  tagline: "Especialistas em pneus. Confiança desde o primeiro kilómetro.",
  city: "Póvoa de Santa Iria",
  address: "Praceta Jaime Cortesão, 6 — 2625-170 Póvoa de Santa Iria, Portugal",
  mapUrl: "https://maps.app.goo.gl/NqvSngPrrpAzgPK2A",
  phone: "+351 968 691 367",
  phoneHref: "tel:+351968691367",
  landline: "+351 219 592 340",
  landlineHref: "tel:+351219592340",
  whatsapp: "+351968691367",
  whatsappHref: "https://wa.me/351968691367?text=Olá,%20gostaria%20de%20pedir%20um%20orçamento",
  email: "globalpneus.cmft@gmail.com",
  googlePlaceId: "ChIJ4TUyMuouGQ0R8QPucx7Zjbk",
  googleReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJ4TUyMuouGQ0R8QPucx7Zjbk",
  googleMapsListingUrl: "https://search.google.com/local/reviews?placeid=ChIJ4TUyMuouGQ0R8QPucx7Zjbk",
  hours: [
    { day: "Segunda a Sexta", time: "09:00 — 13:00  ·  14:30 — 18:30" },
    { day: "Sábado", time: "09:00 — 13:00" },
    { day: "Domingos e Feriados", time: "Encerrado" },
  ],
};

export const SERVICES = [
  {
    key: "troca",
    title: "Troca de Pneus",
    desc: "Montagem e desmontagem rápida com equipamento de última geração para todas as medidas.",
    icon: "Wrench",
  },
  {
    key: "alinhamento",
    title: "Alinhamento de Direção",
    desc: "Alinhamento computorizado 3D com precisão para um desgaste uniforme dos pneus.",
    icon: "Target",
  },
  {
    key: "calibragem-rodas",
    title: "Calibragem de Rodas",
    desc: "Calibragem eletrónica de rodas para eliminar vibrações e prolongar a vida útil dos pneus.",
    icon: "Gauge",
  },
  {
    key: "ajuste-pressao",
    title: "Ajuste da Pressão dos Pneus",
    desc: "Verificação e ajuste rigoroso da pressão dos pneus para maior segurança e menor consumo.",
    icon: "Wind",
    free: true,
  },
  {
    key: "reparacao",
    title: "Reparação de Furos",
    desc: "Reparação profissional de furos e cortes com garantia, sem troca desnecessária.",
    icon: "Shield",
  },
  {
    key: "travoes",
    title: "Travões",
    desc: "Diagnóstico, substituição de pastilhas, discos de travão.",
    icon: "Disc",
  },
  {
    key: "lampadas",
    title: "Substituição de Lâmpadas",
    desc: "Troca rápida de lâmpadas dos faróis, mínimos, piscas e luzes interiores.",
    icon: "Lightbulb",
  },
  {
    key: "focagem-farois",
    title: "Focagem de Faróis",
    desc: "Regulação e alinhamento dos faróis para máxima visibilidade noturna e segurança.",
    icon: "Focus",
  },
];

export const PRICING = [
  { service: "Alinhamento de direção" },
  { service: "Focagem de Faróis (Nevoeiro também)" },
  { service: "Calibragem de rodas ligeiro" },
  { service: "Desmontagem / Montagem roda ligeiro ou comercial" },
  { service: "Teste diagnóstico sensores TPMS" },
  { service: "Reparação de furos (poderá ser necessário calibragem)" },
  { service: "Montagem pastilhas / discos de travão" },
  { service: "Montagem c/ calib. + válvula pneus de mota (C/ ou S/ veículo)" },
  { service: "Montagem c/ calib. + válvula pneus não fornecidos pela firma" },
];

export const FEATURED_TIRES = [
  {
    brand: "Michelin",
    model: "Primacy 5",
    size: "205/55 R16",
    image: "/tires/michelin-primacy-5.png",
    description:
      "Pneu premium de turismo concebido para condução urbana e estrada. Equilíbrio único entre conforto, segurança e durabilidade.",
    highlights: [
      "Travagem curta em piso molhado",
      "Baixo consumo de combustível",
      "Quilometragem prolongada",
    ],
  },
  {
    brand: "Hankook",
    model: "K137",
    size: "225/40 R18",
    image: "/tires/hankook-k137.png",
    description:
      "Pneu desportivo Ventus evo com tecnologia de origem em marcas premium como Audi e BMW. Para condução dinâmica e alto desempenho.",
    highlights: [
      "Aderência superior em curva",
      "Travagem dinâmica em seco e molhado",
      "Estabilidade a alta velocidade",
    ],
  },
  {
    brand: "Taurus",
    model: "Summer 3",
    size: "195/55 R16",
    image: "/tires/taurus-summer3.png",
    description:
      "Pneu de verão fabricado pela Michelin Group, que garante segurança e desempenho fiável a um preço muito competitivo.",
    highlights: [
      "Excelente relação qualidade/preço",
      "Boa aderência em piso seco e molhado",
      "Resistência ao desgaste comprovada",
    ],
  },
  {
    brand: "Sailun",
    model: "Atrezzo Elite 2",
    size: "185/65 R15",
    image: "/tires/sailun-atrezzo-elite2.png",
    description:
      "Pneu de turismo confortável e silencioso, ideal para utilitários e citadinos. Tecnologia eficiente para o dia-a-dia.",
    highlights: [
      "Condução silenciosa e confortável",
      "Baixa resistência ao rolamento",
      "Preço acessível com qualidade",
    ],
  },
];

export const TIRE_PRICING = [
  { size: "175/65 R14", category: "Cidade", from: "45€" },
  { size: "185/65 R15", category: "Utilitário", from: "52€" },
  { size: "195/65 R15", category: "Utilitário", from: "58€" },
  { size: "205/55 R16", category: "Desportivo", from: "68€" },
  { size: "215/55 R17", category: "SUV/Berlina", from: "85€" },
  { size: "225/45 R18", category: "Desportivo", from: "98€" },
  { size: "235/55 R19", category: "SUV", from: "125€" },
  { size: "255/35 R20", category: "Premium", from: "165€" },
];

export const STATS = [
  { text: "+20 anos ao seu lado para o melhor aconselhar" },
  { text: "Um universo de marcas disponíveis" },
  { text: "Montagem expresso ou com marcação se for necessário" },
  { text: "+300 clientes satisfeitos" },
];

export const BRANDS = [
  { name: "Hankook", logo: "/logo-hankook.png", url: "https://www.hankooktire.com/global/en/home.html" },
  { name: "Michelin", logo: "/brands/michelin.png", url: "https://www.michelin.pt/" },
  { name: "Continental", logo: "/brands/continental.png", url: "https://www.continental-pneus.pt/" },
  { name: "Pirelli", logo: "/brands/pirelli.png", url: "https://www.pirelli.com/tyres/pt-pt/carro/homepage" },
  { name: "Bridgestone", logo: "/brands/bridgestone.png", url: "https://www.bridgestone.pt/" },
  { name: "Goodyear", logo: "/brands/goodyear.png", url: "https://www.goodyear.eu/pt_pt/consumer.html" },
  { name: "Dunlop", logo: "/brands/dunlop.png", url: "https://www.dunlop.eu/pt_pt/consumer.html" },
  { name: "Laufenn", logo: "/brands/laufenn.png", url: "https://www.laufenn-tyre.com/pt/" },
  { name: "Sailun", logo: "/brands/sailun.png", url: "https://www.sailuntire.com/" },
  { name: "Taurus", logo: "/brands/taurus.png", url: "https://www.taurus-tyres.com/" },
  { name: "Uniroyal", logo: "/brands/uniroyal.png", url: "https://www.uniroyal.pt/" },
];
